import {
    Route,
    Routes,
} from 'react-router-dom';
import {PricingConfigProvider} from '@flexinet/pricing-components';

import {IndexPage} from './pages/IndexPage';
import {authenticatedPricingConfig} from '../../config/pricing';

// A route table and nothing else, so the module can grow a sub-route without
// anyone editing config/routes.tsx. FNP-1412.
//
// The pricing config moves here from routes.tsx because it is this module's
// dependency, not the router's: every route the module adds needs it, and the
// provider is what useApplicationProducts reads inside IndexPage.
//
// Deliberately does no permission checking. IndexPage gates itself on
// GetDashboard and waits on `authorizing` before deciding (FNP-1410). An earlier
// layout in this module gated on 'ListApplicationProducts' -- an action absent
// from the deployed schema -- and was deleted for it; this one does not repeat
// that by holding no opinion about permissions at all.
export const ApplicationProductsLayout = () => {
    return (
        <PricingConfigProvider config={authenticatedPricingConfig}>
            <Routes>
                <Route
                    path='/'
                    element={<IndexPage/>}
                />
            </Routes>
        </PricingConfigProvider>
    );
};
